module.exports = __webpack_public_path__ + "static/img/bg-2.d2b65239.png";